export function getCsrfToken(): string {
  return document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content || ""
}

export async function downloadFile(url: string, body: Record<string, unknown>, fallbackFilename: string) {
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": getCsrfToken(),
    },
    body: JSON.stringify(body),
  })

  if (!response.ok) {
    const data = await response.json().catch(() => ({}))
    throw new Error(data.error || "Une erreur est survenue")
  }

  const blob = await response.blob()
  const disposition = response.headers.get("Content-Disposition")
  const filenameMatch = disposition?.match(/filename="?(.+?)"?$/)
  const filename = filenameMatch?.[1] || fallbackFilename

  const a = document.createElement("a")
  a.href = URL.createObjectURL(blob)
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(a.href)
}
